import { Info } from 'lucide-react'
import { CalendarLookupTable } from '@/components/CalendarLogicTemplates/CalendarLookupTable'

/**
 * Standalone admin page to VIEW the calendar lookup table (read-only). Reuses
 * the same table the "Select from Calendar" value chooser opens.
 */
export default function AdminCalendarLookup() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">
          Calendar Lookup Table
        </h1>
        <p className="mt-1 text-base text-muted-foreground">
          PAW End / POG Complete per Calendar Year × Event × DC. A “Select from
          Calendar” rule reads these per event when dates are instantiated.
        </p>
      </div>

      <div className="flex items-center gap-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm text-muted-foreground">
        <Info className="h-4 w-4 shrink-0" />
        Read-only reference data, sourced from the{' '}
        <code className="rounded bg-muted px-1 py-0.5 text-xs">
          rms_dc_event_calendar_curr_vw
        </code>{' '}
        view.
      </div>

      <CalendarLookupTable scrollClassName="max-h-[calc(100vh-320px)]" />
    </div>
  )
}
